<template>
  <ul>
    <li v-for="(item, index) in listData" :key="index" :title="item.mistakes_id">
      <div class="left" :title="item.exam_title">
        <b>{{item.exam_title}}</b>
        <i>{{item.updated_at}}</i>
      </div>
      <div class="right">
        <a @click="gotoTest(item.mistakes_id)" class="redo"><img src="../../assets/icon/wrongbank_icon_pen.png" alt=""> 重做</a>
        <a class="check" @click="showDel(item.mistakes_id)"><img src="../../assets/icon/wrongbank_icon_del.png" alt=""> 移除</a>
      </div>
    </li>
    <!-- 原设计稿
    <li>
      <div class="left">
        <b>领学班</b>
        <i>2018-06-14</i>
      </div>
      <div class="right">
        <a href="" class="redo"><img src="../../assets/icon/wrongbank_icon_pen.png" alt=""> 重做</a>
        <a href="" class="check">查看解析</a>
      </div>
    </li>
    -->
  </ul>
</template>

<script>
export default {
  name: 'WrongBankList',
  data () {
    return {
      listData: {}
    }
  },
  props: [
    'examId'
  ],
  methods: {
    getWrongList () {
      let data = {
        exam_id: this.examId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_item_wrong_question',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.listData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    gotoTest (mistakesId) {
      this.$router.push({name: 'WrongTest', query: {exam_id: mistakesId, number: 1}})
    },
    showDel (id) {
      this.$emit('listenDel', id)
    }
  },
  mounted () {
    this.getWrongList()
  }
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/exam/WrongBankList.vue